import { TSvgComponentProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * This renders a rounded rectangular European Union Flag SVG component so it can easily be
 * customized at runtime.
 *
 * @param {{size: number}}
 */
export function FlagEU({ size = 32, ...rest }: TSvgComponentProps) {
  return (
    <svg
      height={size}
      id="FlagEU"
      viewBox="0 0 512 340"
      width={size * 1.5}
      {...rest}
    >
      <g id="eu">
        <path d="M0-.7h512v341.3H0z" fill="#00349a" />

        <path
          d="m149.1 174 11.2-8h-13.8l-4.3-13.2L138 166h-13.8l11.1 8-4.2 13.2 11.1-8.1 11.2 8.1zM206 75.5l11.1-8.1h-13.7l-4.3-13.1-4.2 13.1h-13.8l11.1 8.1-4.2 13.1 11.1-8.1 11.2 8.1zm-41.6 41.7 11.1-8.1h-13.8L157.5 96l-4.3 13.1h-13.8l11.2 8.1-4.3 13.1 11.2-8.1 11.1 8.1zm0 113.7 11.1-8.1h-13.8l-4.2-13.1-4.3 13.1h-13.8l11.2 8.1-4.3 13.1 11.2-8.1 11.1 8.1zm41.6 41.7 11.1-8.1h-13.7l-4.3-13.1-4.2 13.1h-13.8l11.1 8.1-4.2 13.1 11.1-8.1 11.2 8.1zM376.7 174l11.1-8H374l-4.2-13.2-4.3 13.2h-13.8l11.2 8-4.3 13.2 11.2-8.1 11.1 8.1zm-56.9-98.5 11.1-8.1h-13.8l-4.2-13.1-4.3 13.1h-13.7l11.1 8.1-4.3 13.1 11.2-8.1 11.1 8.1zm41.6 41.7 11.2-8.1h-13.8L354.5 96l-4.2 13.1h-13.8l11.1 8.1-4.2 13.1 11.1-8.1 11.2 8.1zm0 113.7 11.2-8.1h-13.8l-4.3-13.1-4.2 13.1h-13.8l11.1 8.1-4.2 13.1 11.1-8.1 11.2 8.1zm-41.6 41.7 11.1-8.1h-13.8l-4.2-13.1-4.3 13.1h-13.7l11.1 8.1-4.3 13.1 11.2-8.1 11.1 8.1zM262.9 60.3l11.1-8.1h-13.7L256 39.1l-4.3 13.1H238l11.1 8.1-4.2 13.1 11.1-8.1 11.1 8.1zm0 227.5 11.1-8.1h-13.7l-4.3-13.1-4.3 13.1H238l11.1 8.1-4.2 13.1 11.1-8.1 11.1 8.1z"
          fill="#ffd538"
        />
      </g>
    </svg>
  );
}
